import { AlarmClock } from "lucide-react";
import { callbackState } from "../lib/callback";

const time = (iso) => new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });

export const TodayCallbacks = ({ leads }) => {
  const due = leads
    .filter((l) => !l.archived && ["overdue", "today"].includes(callbackState(l.callback_at)))
    .sort((a, b) => new Date(a.callback_at) - new Date(b.callback_at));
  if (!due.length) return null;

  const jump = (id) => document.querySelector(`[data-testid="lead-card-${id}"]`)?.scrollIntoView({ behavior: "smooth", block: "center" });

  return (
    <div data-testid="today-callbacks-strip" className="mb-4 bg-amber-950/20 border border-amber-500/40 rounded-md px-4 py-3">
      <div className="flex items-center gap-2 mb-2">
        <AlarmClock className="h-4 w-4 text-amber-400" />
        <span className="font-heading font-bold uppercase tracking-wide text-amber-300 text-sm">Today's callbacks ({due.length})</span>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {due.map((l) => {
          const overdue = callbackState(l.callback_at) === "overdue";
          return (
            <button key={l.id} data-testid={`today-callback-chip-${l.id}`} onClick={() => jump(l.id)}
              className={`shrink-0 text-left rounded border px-3 py-1.5 transition-colors ${overdue ? "border-red-500/60 bg-red-950/40 hover:bg-red-950/70" : "border-amber-500/50 bg-[#13161C] hover:bg-[#1A1E26]"}`}>
              <span className={`block font-mono text-[11px] font-bold ${overdue ? "text-red-300" : "text-amber-300"}`}>
                {time(l.callback_at)}{overdue ? " · late" : ""}
              </span>
              <span className="block text-xs text-white whitespace-nowrap">{l.full_name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
